export const REGEX = {
  phone: /^0[1-9]\d{8}$/,
  email: /^(([^<>()[\]\\.,;:\s@éèàîï"]+(\.[^<>()[\]\\.,;:\s@éèàîï"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
}
